import { render, staticRenderFns } from "./StagingEditorHeader.vue?vue&type=template&id=32b77ec6"
import script from "./StagingEditorHeader.vue?vue&type=script&lang=ts"
export * from "./StagingEditorHeader.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorHeader.vue?vue&type=style&index=0&id=32b77ec6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports